var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.262 11.817L14.589 12.284V1.70898C14.5886 1.33559 14.4661 0.972563 14.2403 0.67522C14.0144 0.377878 13.6976 0.162526 13.338 0.0619812C13.7722 0.0955038 14.1854 0.262432 14.521 0.539907C14.8567 0.817381 15.0984 1.19183 15.213 1.61198L17.451 9.72098C17.5111 9.93668 17.5279 10.1621 17.5007 10.3844C17.4734 10.6066 17.4025 10.8213 17.292 11.016C17.1815 11.2108 17.0336 11.3818 16.8569 11.5193C16.6801 11.6567 16.4779 11.7579 16.262 11.817Z",
    fill: "url(#paint0_linear_101_119)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999969 0.000976562H12.649C13.0468 0.000976563 13.4283 0.159012 13.7096 0.440316C13.9909 0.721621 14.149 1.10315 14.149 1.50098V15.264C14.149 15.5292 14.0436 15.7835 13.8561 15.9711C13.6685 16.1586 13.4142 16.264 13.149 16.264H0.999969C0.734753 16.264 0.480399 16.1586 0.292863 15.9711C0.105326 15.7835 -3.05176e-05 15.5292 -3.05176e-05 15.264V1.00098C-3.05176e-05 0.73576 0.105326 0.481406 0.292863 0.29387C0.480399 0.106333 0.734753 0.000976563 0.999969 0.000976563V0.000976562Z",
    fill: "url(#paint1_linear_101_119)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19197 2.62598H3.69397V3.68298H8.19197V2.62598Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72997 6.23097H10.096V13.631H9.02697L5.10697 8.60797V13.628H3.74197V6.22797H4.80697L8.72598 11.247L8.72997 6.23097Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_119",
    x1: 15.4256,
    y1: 0.0619812,
    x2: 15.4256,
    y2: 12.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF974D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB843B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_119",
    x1: 7.07447,
    y1: 0.000976562,
    x2: 7.07447,
    y2: 16.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF974D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB843B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.5718eac413434c2600ab5c277d7f9884.svg";
export { ForwardRef as ReactComponent };